<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="label"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <Spin v-if="isLoading"></Spin>
    <CheckboxGroup
      style="height: 32px;"
      class="zpa-row middle"
      v-if="!isLoading"
      :value="renderArray"
      @on-change="onInputChange"
    >
      <Checkbox
        v-for="v in renderValues"
        :key="getValue(v)"
        :label="getValue(v)"
        :disabled="disabled"
      >{{getText(v)}}</Checkbox>
    </CheckboxGroup>
  </zpa-form-item>
</template>

<script>
import _ from 'lodash'
import inputMixin from './mixins/input'
import queryMixin from './mixins/query'
import valueTextMixin from './mixins/value-text'
import stringifyMixin from './mixins/stringify'

export default {
  name: 'zpaCheckboxGroup',

  mixins: [
    inputMixin,
    queryMixin,
    valueTextMixin,
    stringifyMixin,
  ],

  data() {
    return {
      renderArray: [],
    }
  },

  props: {
    value: [String, Array],

    values: Array,

    fromModelId: String,

    params: Object,

    from: String, // '1': '手动输入', '2': '数据库请求'},

    getStyle: String, // {value: '1', text: '数据包'},{value: '2', text: 'url'},{value: '3', text: '列表模块'},

    dp: String, // 数据包

    url: String,
  },

  mounted() {
    if (this.renderValue === '') {
      this.renderArray = []
    } else if (!Array.isArray(this.renderValue)) {
      this.renderArray = [this.renderValue]
    }
    console.log('renderValues is:', this.renderValues, '\n renderValue is', this.renderValue)
    this.getRenderValues()
  },
  methods: {
    changeRenderArray() {
      this.renderArray = []
    },
    getRenderValues() {
    },
  },
  watch: {
    renderValue() {
      if (this.renderValue === '') {
        this.renderArray = []
      } else if (!Array.isArray(this.renderValue)) {
        this.renderArray = this.renderValue.split(',')
      }
    },
    fromModelId() {
      this.getRenderValues()
    },
    getStyle() {
      this.getRenderValues()
    },
    params: {
      handler(params, old) {
        if (_.isEqual(params, old)) return
        console.log('render is params.', params)
        this.getRenderValues()
      },
      deep: true,
    },
  },
}
</script>
